import { resolveTransactionId } from "../../../utils/clipboard";

const CREDIT_TYPES = new Set([
  "DEPOSIT_BANK",
  "DEPOSIT_RZ",
  "REFUND_SURPLUS",
  "REFUND_TRANSACTION",
  "REFUND_PROPERTY",
  "REFUND_AUCTION",
  "WITHDRAWAL_REVERSED",
  "REINVEST_REVERSED",
  "CASHBACK_FRAX_FREE",
]);

const PENDING_TYPES = new Set(["WITHDRAWAL_INITIATED"]);

const TYPE_LABELS = {
  DEPOSIT_BANK: "Bank Deposit",
  DEPOSIT_RZ: "Payment Gateway Deposit",
  INVESTMENT_BANK: "Investment Bank",
  INVESTMENT_RZ: "Payment Gateway Investment",
  INVESTMENT_UPI: "UPI Investment",
  FRAX_CONVERTED: "Frax Converted",
  RCO_REGISTERED: "RCO Registered",
  FROZEN_GIFT: "Frozen Gift",
  ADJUSTMENT_FREE: "Available Adjustment",
  ADJUSTMENT_FROZEN: "Frozen Adjustment",
  REFUND_SURPLUS: "Surplus Refund",
  REFUND_TRANSACTION: "Transaction Refund",
  REFUND_PROPERTY: "Property Refund",
  REFUND_AUCTION: "Auction Refund",
  REINVEST: "Investment Allocation",
  REINVEST_REVERSED: "Reinvestment Reversed",
  WITHDRAWAL_INITIATED: "Bank Withdrawal",
  WITHDRAWAL_REVERSED: "Withdrawal Reversed",
  CASHBACK_FRAX_FREE: "Frax Cashback",
  ADJUSTMENT: "Adjustment",
};

const STATUS_LABELS = {
  POSTED: "Completed",
  PENDING: "Pending",
  CREATED: "Pending",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled"
};

const POOL_TYPES = {
  FREE: "Available",
  FROZEN: "Frozen",
}

export function isCreditEntry(row) {
  const direction = String(row?.direction || "").toUpperCase();
  if (direction === "CREDIT") return true;
  if (direction === "DEBIT") return false;
  return CREDIT_TYPES.has(row?.type);
}

export function getLedgerStatus(row) {
  const status = String(row?.status || "").trim();
  if (STATUS_LABELS[status]) return STATUS_LABELS[status];
  return PENDING_TYPES.has(row?.type) ? "Pending" : "Completed";
}


export function formatLedgerStatus(status) {
  if (!status) return "-";
  return STATUS_LABELS[status] || status.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}
export function formatLedgerType(type) {
  if (!type) return "-";
  return TYPE_LABELS[type] || type.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatTransactionId(row) {
  return resolveTransactionId({ row });
}

export function formatPoolType(type) {
  if (!type) return "-";
  return POOL_TYPES[type] || type.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}


export function getLedgerListingLabel(row) {
  const title = row?.title;
  if (title) return title;
  return row?.listingName || row?.projectName || "";
}

export function getLedgerBalanceTotal(row) {
  const free = Number(row?.balanceAfter?.free) || 0;
  const frozen = Number(row?.balanceAfter?.frozen) || 0;
  return free + frozen;
}

export function getLedgerFreeBalance(row) {
  return Number(row?.balanceAfter?.free) || 0;
}

export function getLedgerFrozenBalance(row) {
  return Number(row?.balanceAfter?.frozen) || 0;
}

export function computeLedgerTotals(rows = []) {
  return rows.reduce(
    (acc, row) => {
      const amount = Number(row?.amount) || 0;
      if (isCreditEntry(row)) acc.credits += amount;
      else acc.debits += amount;
      return acc;
    },
    { credits: 0, debits: 0 }
  );
}
